import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { Vector2 } from 'three'
import { KVMarkup } from 'types'

export const useEntryBehavior = <T extends KVMarkup>(
  item: T,
  highlightCommand: KestrelCommands,
  unhighlightCommand: KestrelCommands,
  commandParamName: string
) => {
  const {
    selectedMarkup,
    setSelectedMarkup,
    setPopupMenuStartPosition,
    sendKVCommand,
  } = useKestrel()

  const isSelected = item.id === selectedMarkup?.id

  const handleClick = () => {
    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(80, 20))
    }
    const newSelectedMarkup = isSelected ? undefined : item
    setSelectedMarkup(newSelectedMarkup)

    // Send command to Kestrel to select/deselect the item
    if (sendKVCommand) {
      sendKVCommand({
        command: highlightCommand,
        [commandParamName]: newSelectedMarkup?.id || '',
      })
    }
  }

  const handleHover = () => {
    // Only highlight on hover if no item is currently selected
    if (sendKVCommand && !selectedMarkup) {
      sendKVCommand({
        command: highlightCommand,
        [commandParamName]: item.id,
      })
    }
  }

  const handleHoverEnd = () => {
    // Only unhighlight all if no item is currently selected
    if (sendKVCommand && !selectedMarkup) {
      sendKVCommand({
        command: unhighlightCommand,
      })
    }
  }

  return {
    isSelected,
    handleClick,
    handleHover,
    handleHoverEnd,
  }
}
